import { NgFor } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LbChartWrapperComponent } from "../charts/lb-chart-wrapper/lb-chart-wrapper.component";
import { Chart} from "../../shared/shared.interface";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  standalone: true,
  selector: 'app-lb-chart-echelon',
  templateUrl: './lb-chart-echelon.component.html',
  styleUrls: ['./lb-chart-echelon.component.scss'],
  imports: [
    NgFor,
    LbChartWrapperComponent,
  ]
})
export class LbChartEchelonComponent {

  constructor(private http:HttpClient) {}

  @Input() name?: string;
  @Input() sqas?: string[] = undefined;

  // Type the charts array with the Chart interface
  charts: Chart[] = [];

  ngOnInit() {
    // console.log(this.sqas)
  }


  private setChartsBasedOnName(name?: string): void {
    switch (name) {
      case 'The market':
        this.charts = [
          {
            chart_type: 'bar',
            by_column: 'sector',
            style: 'width:79vw'
          }
        ];
        break;
      case 'My company':
        this.charts = [
          {
            chart_type: 'bar',
            by_column: 'seniority',
            style: 'width:79vw'
          }
        ];
        break;
      case 'My team':
        this.charts = [
          {
            chart_type: 'bar',
            by_column: 'company_type',
            style: 'width:79vw'
          }
        ];
        break;
      case 'Priorities':
        this.charts = [
          {
            chart_type: 'bar',
            by_column: 'countries',
            style: 'width:79vw'
          }
        ];
        break;
      case 'Purpose and values':
        this.charts = [
          {
            chart_type: 'bar',
            by_question: '3.3',
            style: 'width:79vw'
          }
        ];
        break;
      case 'Strategy':
        this.charts = [
          {
            chart_type: 'bar',
            by_column: 'sector',
            style: 'width:39vw'
          },
          {
            chart_type: 'bar',
            by_column: 'seniority',
            style: 'width:39vw'
          }
        ];
        break;
      case 'Skills':
        this.charts = [
          {
            chart_type: 'bar',
            by_column: 'company_type',
            style: 'width:25vw'
          },
          {
            chart_type: 'bar',
            by_column: 'countries',
            style: 'width:25vw'
          },
          {
            chart_type: 'bar',
            by_question: '3.3',
            style: 'width:25vw'
          }
        ];
        break;
      default:
        this.charts = [];
        break;
    }
  }
}
